import React from "react";
import { Link } from "react-router-dom";
import carscrap from "../Images/carscrap.png";
import FAQ from "./FAQ.jsx";
import SEO from "../Components/SEO";

const CarScrap = () => {
  return (
    <>
      <SEO 
        title="Car Scrap & Vehicle Recycling" 
        description="Hassle-free vehicle recycling and old car disposal. Get the best scrap price with proper ethical documentation."
        keywords="car scrap, vehicle recycling, sell old car, car scrap dealer, end-of-life vehicle disposal"
      />
      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
          font-family:Arial, Helvetica, sans-serif;
        }

        .hero{
          background:#fff;
          padding:80px 8%;
        }

        .container{
          max-width:1300px;
          margin:auto;
          display:flex;
          align-items:center;
          justify-content:space-between;
          gap:60px;
          flex-wrap:wrap;
        }

        .left{
          flex:1;
          min-width:320px;
        }

        .tag{
          display:inline-block;
          padding:8px 18px;
          background:#FFF5D6;
          color:#0A2E73;
          font-weight:600;
          border-radius:30px;
          margin-bottom:20px;
        }

        .left h1{
          font-size:52px;
          color:#0A2E73;
          line-height:1.2;
          margin-bottom:20px;
        }

        .left h2{
          font-size:30px;
          color:#0A2E73;
          margin:35px 0 15px;
        }

        .left p{
          font-size:17px;
          color:#555;
          line-height:1.9;
          margin-bottom:15px;
        }

        .btn{
          display:inline-block;
          margin-top:25px;
          padding:15px 35px;
          background:#0A2E73;
          color:#FFD700;
          text-decoration:none;
          border-radius:40px;
          font-weight:bold;
          transition:.3s ease;
        }

        .btn:hover{
          background:#FFD700;
          color:#0A2E73;
        }

        .right{
          flex:1;
          min-width:360px;
          transform: translateY(-110px); 
        }

        .right img{
          width:100%;
          height:400px;
          margin-bottom:100px;
          margin-top:2px;
          object-fit:cover;  
          border-radius:20px;
          box-shadow:0 15px 35px rgba(0,0,0,.15);
        }

        @media(max-width:992px){

          .container{
            flex-direction:column-reverse;
            text-align:center;
          }

          .left h1{
            font-size:42px;
          }

          .left h2{
            font-size:28px;
          }

        }

        @media(max-width:768px){

          .hero{
            padding:60px 5%;
          }

          .left h1{
            font-size:34px;
          }

          .left h2{
            font-size:24px;
          }

          .left p{
            font-size:16px;
          }

          .btn{
            padding:14px 28px;
          }

        }

        @media(max-width:480px){

          .left h1{
            font-size:28px;
          }

          .left h2{
            font-size:22px;
          }

          .left p{
            font-size:15px;
          }

        }

      `}</style>

      <section className="hero">

        <div className="container">

          <div className="left">

            <span className="tag">
              Car Scrap Dealer
            </span>

            <h1>
              Buy & Sell Old Car Scrap at the Best Price
            </h1>

            <p>
              We purchase all types of old, accidental, damaged, unused,
              and junk cars for recycling. Our team offers doorstep pickup,
              transparent valuation, and instant payment for all vehicle
              scrap requirements.
            </p>

            <h2>
              About Car Scrap
            </h2>

            <p>
              Car scrap includes damaged vehicles, old cars, accidental
              vehicles, rusted body parts, engines, gearboxes, alloy wheels,
              batteries, and other recyclable automobile components. We ensure
              environmentally responsible dismantling and recycling while
              offering the best market prices to our customers.
            </p>

            <p>
              Whether you are an individual vehicle owner, workshop,
              insurance company, fleet operator, or automobile dealer,
              we provide fast and reliable car scrap collection services
              with complete documentation and hassle-free processing.
            </p>

            <Link to="/contact" className="btn">
              Contact Us
            </Link>

          </div>

          <div className="right">

            <img
              src={carscrap}
              alt="Car Scrap Dealer"
              loading="lazy"
            />

          </div>

        </div>

      </section>
        <FAQ />


    </>
  );
};

export default CarScrap;